import React, { useState } from 'react';
import {
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

import './styles.css';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { Boleto } from './interfaces';
import TabelaMensalidades from './TabelaMensalidades';
import TabelaPrincipalMensalidades from './TabelaPrincipalMensalidades';

interface DetalhesSegundaViaProps {
  onVoltar?: () => void;
  mensalidades: Boleto[];
  isPessoaFisica: boolean;
  codigoEmpresa?: string;
}
const DetalhesSegundaVia: React.FC<DetalhesSegundaViaProps> = ({ onVoltar, mensalidades, isPessoaFisica, codigoEmpresa }) => {
  const [showErrorTable, setShowErrorTable] = useState<boolean>(false);

  const { textStyleAccessibility } = useAccessibility();

  return (
    <div className="container-mensalidades">

      <Typography style={textStyleAccessibility} className="mensalidades-title">
        2ª via de boletos
      </Typography>

      <Typography style={textStyleAccessibility} className="mensalidades-subtitle">
        Apenas serão exibidos boletos:
      </Typography>

      <ul className="mensalidades-lista" style={textStyleAccessibility}>
        <li>para a pessoa pagadora do contrato;</li>
        <li>se o boleto ainda não foi pago;</li>
        <li>até três mensalidades em aberto;</li>
        <li>boletos negociados (parcelamentos) não são exibidos no portal.</li>
      </ul>

      <div className="atencao-container">
        <FontAwesomeIcon icon={faTriangleExclamation} className="atencao-icon" size="lg" />
        <div className="atencao-content">
          <Typography className="atencao-title" style={textStyleAccessibility}>
            ATENÇÃO:
          </Typography>
          <Typography className="atencao-text" style={textStyleAccessibility}>
            Atraso superior a {codigoEmpresa ? '30' : '50'} dias consecutivos pode resultar em <span className="atencao-text-bold">suspensão dos atendimentos</span>.
          </Typography>
          <Typography className="atencao-text" style={textStyleAccessibility}>
            Para evitar suspensão ou cancelamento do plano, o pagamento deve sempre iniciar pela mensalidade 
            mais antiga em aberto.
          </Typography>
          <Typography className="atencao-text" style={textStyleAccessibility}>
            Pelo sistema, essa parcela já vem selecionada e não pode ser desmarcada — <span className="atencao-text-bold">é possível apenas incluir 
            mensalidades adicionais</span>.
          </Typography>
        </div>
      </div>

      <Typography className="selecione-mensalidades-text" style={textStyleAccessibility}>
        Selecione abaixo as mensalidades que deseja quitar:
      </Typography>

      {showErrorTable ? (
        <TabelaMensalidades 
          mensalidades={mensalidades} 
          isPessoaFisica={isPessoaFisica}
          codigoEmpresa={codigoEmpresa}
        />
      ) : (
        <TabelaPrincipalMensalidades 
          mensalidades={mensalidades}
          isPessoaFisica={isPessoaFisica}
          codigoEmpresa={codigoEmpresa}
        />
      )}
    </div>
  );
};

export default DetalhesSegundaVia;